import {IURIParameter as UrlParam} from "../";
import {LogCat} from '../../log/services/log.manager.categories';
import {LogManager} from '../../log/services/log.manager';
import * as _ from "lodash";

export class Serialization {
	/** serialize a variable or list of variables to URL encoded string.
		* the encoded string will be later decoded by web-api.
		* support is for primitives, objects, object[], primitive[].
		* Example, a parameter called id is a vector with 2 identical element of a complex type:
		* id=>[{B1:"b0", B2:"b2",A:{A1:"a1",A2:22}},{B1:"b0", B2:"b2",A:{A1:"a1",A2:22}}]
		* result serialization string : id[0].B1 = "b0" & id[0].B2="b2" & id[0].A.A1="a1" & id[0].A.A2=22&id[1].B1 =
		* "b0" & id[1].B2="b2" & id[1].A.A1="a1" & id[1].A.A2=22
		*/
	public static toURLString(param:UrlParam | UrlParam[]):string {
		let retVal = "";
		if (!Array.isArray(param)) {
			retVal = this.handleParameter(<UrlParam> param);
		} else {
			param.forEach((currParam:UrlParam, index:number) => {
				let currParamStr = this.handleParameter(currParam);
				if ((index > 0) && (currParamStr !== "")) {
					retVal += "&";
				}
				retVal += currParamStr;
			});
		}
		LogManager.debug(LogCat.Utils.Serialization, "return serialized param " + retVal + " for object ", param);
		return retVal;
	}


	/**
		* convert all properties which comply with iso date format to date objects
		* @param input an object with sub properties which contain dates encoded as iso date strings
		* @param regexKey a regular expression to decide which keys to process
		*/
	public static convertDateStringsToDates(input:any, regexKey?:RegExp):any {
		if (input) {
			LogManager.debug(LogCat.Utils.Serialization, "convertDateStringsToDates for ", input);

			if (typeof (input) === "string"){
				return this.getAsDate(input) || input;
			}
			if (typeof input !== "object") {
				return input;
			}
			/* tslint:disable */
			for (let key in input) {
				/* tslint:enable */
				let value = input[key];
				// Check for string properties which look like dates.
				//if ((typeof value === "string") && ((!(regexKey)) || regexKey.test(key)) && (match = value.match(regexIso8601))) {
				if ((typeof value === "string") && (!(regexKey) || regexKey.test(key))) {
					let asDate:Date = this.getAsDate((value));
					if (asDate != null) {
						LogManager.debug(LogCat.Utils.Serialization, value + " detected as date");
						input[key] = asDate;
					}
				} else if (typeof value === "object") {
					// Recurse into object
					this.convertDateStringsToDates(value, regexKey);
				}
			}
		}
		return input;
	}

	public static getAsDate(value:any):Date {
		/* tslint:disable */
		const regexIso8601 = /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(\.[0-9]+)?(Z|[+-](?:2[0-3]|[01][0-9]):[0-5][0-9])?$/;
		/* tslint:enable */
		let match:RegExpMatchArray;
		if ((typeof value === "string") && (match = value.match(regexIso8601))) {
			//LogManager.debug(LogCat.Utils.Serialization, "passed regular expression for date"); // too heavy for client side logging
			// moment date parsing is really slow. we fallback to standard dates for performance reasons
			//let asDate:Date = moment(match[0]).toDate(); //
			let asDate = new Date(match[0]);
			// let asDate:Date = DateWrapper.fromISOString(match[0]);
			LogManager.debug(LogCat.Utils.Serialization, "date object retrieved for " + value, asDate);
			return asDate;
		}
		return null;
	}

	// handling a specific parameter for url serialization.
	public static handleParameter(p:UrlParam):string {
		//LogManager.debug(LogCat.Utils.Serialization, "handle parameter for ", p); // too heavy on client side console

		let retVal = "";
		if (Array.isArray(p.pVal)) {
			(p.pVal).forEach((currObj:any, index:number) => {
				let currPStr= "";
				if (_.isObject(currObj)) {
					currPStr = this.handleParameter({pVal: currObj, pName: p.pName + "[" + index + "]"});
				}else{
					currPStr = p.pName+ "=" +encodeURIComponent(currObj);
				}

				if ((index > 0) && (currPStr !== "")) {
					retVal += "&";
				}
				retVal += currPStr;
			});
		} else if (typeof p.pVal !== 'object' && typeof p.pVal !== 'undefined') {
			// we have a simple type at the leaf of the object
			retVal = p.pName + "=" + encodeURIComponent(p.pVal);
		} else {
			if (p.pVal != null && typeof p.pVal !== 'undefined') {
				// special dates handling - there may still be issues here with cross frames and invalid dates
				if (p.pVal instanceof Date) {
					//retVal = p.pName + "=" + (p.pVal as Date).toISOString();
					retVal = p.pName + "=" + (p.pVal as Date).toJSON();
				} else {
					let keyNames:string[] = Object.keys(p.pVal);
					keyNames.forEach((keyName:any, index:number) => {
						if (p.pVal[keyName] != null) {
							let currP:UrlParam = {
								pVal: p.pVal[keyName],
								pName: p.pName + "." + keyName
							};
							let currParamStr = this.handleParameter(currP);
							if ((index > 0) && (currParamStr !== "")) {
								retVal += "&";
							}
							retVal += currParamStr;
						}
					});
				}
			}
		}
		return retVal;
	}
}
